import {
  createHistory,
  reduceHistory,
  type TemplateEditAction,
} from "@repo/print-pdf/arbre/print/template";
import type { PrintTemplate } from "@repo/types";
import { useCallback, useReducer } from "react";

export type DraftAction = TemplateEditAction | { type: "undo" | "redo" };
export type DraftDispatch = (action: DraftAction) => void;

/**
 * Brouillon du modèle en cours d'édition, avec historique annuler / rétablir. `saved` est le modèle enregistré
 * sur le serveur : il sert de point de départ et de référence pour savoir s'il reste des modifications non
 * enregistrées. La logique d'édition est dans `@repo/print-pdf` (fonctions pures, testées).
 */
export function useTemplateDraft(saved: PrintTemplate) {
  const [history, rawDispatch] = useReducer(
    reduceHistory,
    saved,
    createHistory,
  );

  // L'heure sert à regrouper les frappes rapprochées : elle est fournie ici (le réducteur doit rester pur).
  const dispatch = useCallback<DraftDispatch>(
    (action) => rawDispatch({ ...action, at: Date.now() }),
    [],
  );

  const draft = history.present;
  return {
    draft,
    dispatch,
    canUndo: history.past.length > 0,
    canRedo: history.future.length > 0,
    hasUnsavedChanges: JSON.stringify(draft) !== JSON.stringify(saved),
  };
}
